import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from "../../views/authentication/authentication.service";


@Injectable()
export class HumanResourcesService {

  constructor(private http: HttpClient,  private authService: AuthenticationService) {
  }

  getHeaders(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.authService.token);
    return headers;
  }

  getData() : Observable<any>  {
    return this.http.get(environment.HR + '/hr/complete-structure/', { headers: this.getHeaders() })
  }

  whoIs(key : any) : Observable<any> {
    return this.http.get(environment.HR + '/hr/entity/'+ key, { headers: this.getHeaders() })
  }

  changeParent(change: any) : Observable<any>  {

    return this.http.post(environment.API + '/hr/change-parent/',change, { headers: this.getHeaders() })
  }

  getCosts(key: any) : Observable<any>  {
    return this.http.get(environment.API + '/details/totals-by-account/'+ key, { headers: this.getHeaders() })
    
  }

  getTotalCorp(key: any) : Observable<any>  {
    return this.http.get(environment.API + '/details/total-corporate-unit/'+ key, { headers: this.getHeaders() })
  }

  getOrphans() : Observable<any>  {
    return this.http.get(environment.API + '/hr/orphan-resources/', { headers: this.getHeaders() })
  }

  addResource(resource: any) : Observable<any>  {

    return this.http.post(environment.HR + '/hr/add-entity/',resource, { headers: this.getHeaders() })
  }

  changeInfo(resource: any) : Observable<any>  {

    return this.http.post(environment.HR + '/hr/edit-entity/',resource, { headers: this.getHeaders() })
  }

  getTotalPerson(key: any) : Observable<any>  {
    return this.http.get(environment.API + '/details/total-by-person/'+ key, { headers: this.getHeaders() })
  }

  addLineEvent(data:any): Observable<any> {
    
    return this.http.post(environment.HR + '/hr/save-line-change/', data, { headers: this.getHeaders() })
  }


}



// WEBPACK FOOTER //
// ./src/app/views/human-resources/human-resources.service.ts